import React, {useEffect, useState, useRef} from "react";
import {createUseStyles, useTheme} from "react-jss";
import FormWithApi from "../../../../../../../../artibulles-cis/FormWithApi/FormWithApi";
import {useHistory, useLocation} from "react-router-dom";
import {toast} from "react-toastify";

import InvoiceItemsEditForm from "./InvoiceItemsEditForm";

import _ from "lodash";
const {format, parseISO} = require("date-fns");
//eslint-disable-next-line
const styles = createUseStyles((theme) => ({}));

const Component = React.memo(function Component(props) {
    const {SaleInvoiceID, InvoiceItemID, CloseCard} = props;
	console.log("SaleInvoiceID",SaleInvoiceID)

    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** CONST ******************/
    const Ref_TabNavContent = React.useRef(null);
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-bms.artibulles.com";

    const Location = useLocation();
    const PathName = Location.pathname;

    // console.log("SupplierEditBankAccount_Path", PathName);

    const InitialCall = {type: "Edit", ID: InvoiceItemID};

    const History = useHistory();

    const FinalAPIUrlRelative = {
        MAIN: `${ProdURL}/api/saleinvoices/invoiceitems/invoiceitem`,
        DELETE: "",
        PUT: "",
        POST: "", //Call when creating a new Entry to send back the initial options if needed
    };

    //Redirect URL when Leaving the Form
    const HandleRedirection = (args) => {
        if (args.typeOfSubmit === "SaveAndQuit" || args.typeOfSubmit === "QuitNoSave") {
            CloseCard();
        }
    };
    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    /***************** FORMATTING THE DATA COMING FROM THE SERVER TO INITATE THE FORM ****************/
    const FormatDataServerToForm = (response) => {
        let data = response.data;
        let SaleInvoiceItem = data.SaleInvoiceItem;
        let SaleItemTypeSelectOptions = data.SaleItemTypeSelectOptions;

        let SaleItemTypeInitial = SaleInvoiceItem ? SaleInvoiceItem.TypeOfPurchase : null;
        if (SaleItemTypeInitial) {
            SaleItemTypeInitial = _.find(SaleItemTypeSelectOptions, {label: SaleItemTypeInitial}).value;
        }

        //SET THE INITIAL FORM VALUES

        var InitialFormValues = {
            InitiaFormValues: {
                ApiID: SaleInvoiceItem ? SaleInvoiceItem._id : "new",
                SupplierRefCode: SaleInvoiceItem ? SaleInvoiceItem.SupplierRefCode : null,
                SupplierDescription: SaleInvoiceItem ? SaleInvoiceItem.SupplierDescription : null,
                InternalDescription: SaleInvoiceItem ? SaleInvoiceItem.InternalDescription : null,
                TypeOfPurchase: SaleItemTypeInitial,
                keywords: SaleInvoiceItem ? SaleInvoiceItem.keywords : null,
                UnitPriceVATExcluded: SaleInvoiceItem ? SaleInvoiceItem.UnitPriceVATExcluded : null,
                Quantity: SaleInvoiceItem ? SaleInvoiceItem.Quantity : null,
                Currency: SaleInvoiceItem ? SaleInvoiceItem.Currency : null,
                CurrencyExchangeRate: SaleInvoiceItem ? SaleInvoiceItem.CurrencyExchangeRate : null,
                VATPercent: SaleInvoiceItem ? SaleInvoiceItem.VATPercent : null,
                CalcVATAmount: SaleInvoiceItem ? SaleInvoiceItem.CalcVATAmount : null,
                CalcTotalVATExcluded: SaleInvoiceItem ? SaleInvoiceItem.CalcTotalVATExcluded : null,
                CalcTotalVATIncluded: SaleInvoiceItem ? SaleInvoiceItem.CalcTotalVATIncluded : null,
                ExpectedDeliveryDateIso: SaleInvoiceItem ? SaleInvoiceItem.ExpectedDeliveryDateIso : null,
                Delivered: SaleInvoiceItem ? SaleInvoiceItem.Delivered : null,
                DeliveryDateIso: SaleInvoiceItem ? SaleInvoiceItem.DeliveryDateIso : null,
                ref_SaleInvoice: SaleInvoiceItem ? SaleInvoiceItem.ref_PurchaseInvoice : null,
            },
            SelectOptions: {
                TypeOfPurchase: SaleItemTypeSelectOptions,
            },
            SubOptionsFull: {},
            // FilesUploaders: {
            //     fileuploaderName: data.tutorial.Files,
            // },
        };
        return InitialFormValues;
    };
    /***************** FORMATTING THE DATA COMING FROM THE SERVER TO INITATE THE FORM ****************/

    /***************** FORMATTING THE DATA WHEN SUBMITTING THE FORM BEFORE SENDING BACK TO THE SERVER ****************/
    const FormatDataFormToServer = (FullSubmission) => {
        //USE THIS TO CHECK YOUR DATA FORMAT AND FORMATTING THE DATA CORRECTLY
        // console.log("FormatDataFormToServer", FullSubmission);
        //USE THIS TO CHECK YOUR DATA FORMAT AND FORMATTING THE DATA CORRECTLY

        if (FullSubmission) {
            //If data were sent back from the form
            let values = FullSubmission.values;

            if (values) {
                let ServerData = {
                    API_id: values.ApiID,
                    SaleInvoiceItem: {
                        Updatable: {
							ref_SaleInvoice: SaleInvoiceID,
                            SupplierRefCode: values.SupplierRefCode,
                            SupplierDescription: values.SupplierDescription,
                            InternalDescription: values.InternalDescription,
                            TypeOfPurchase: values.TypeOfPurchase,
                            keywords: values.keywords,
                            UnitPriceVATExcluded: values.UnitPriceVATExcluded,
                            Quantity: values.Quantity,
                            Currency: values.Currency,
                            CurrencyExchangeRate: values.CurrencyExchangeRate,
                            VATPercent: values.VATPercent,
                            
                        },
                    },
                };
                //this is what will be sent back to the server
                return ServerData;
            }
        }
    };
    /***************** FORMATTING THE DATA WHEN SUBMITTING THE FORM BEFORE SENDING BACK TO THE SERVER ****************/
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <div>
            <FormWithApi
                // WithCardModal={Id ? false : true}
                // WithCardModal={true}
                CardModalOptions={{
                    ParentCompRef: Ref_TabNavContent,
                    // CloseCard={HandleCloseCardCreate}
                    // WithPerfectScrollbar={true}
                    CardWindowPaddingVertical: "10px",
                    CardWindowPaddingHorizontal: "10px",
                    ShowCard: false,
                    WindowBackgroundColor: "rgba(0,0,0,0.3)",
                    CardBackgroundColor: "white",
                    CardBackground: "white",
                    // ClassExtendCard: classes.ClassExtendCard,
                }}
                // OpenInViewMode={Id ? (Id === "new" ? false : true) : false}
                // SwitchEditMode="FieldClick"
                toast={toast}
                // DevMode={true}
                InitialCall={InitialCall}
                // RedirectUrlOnQuit={RedirectUrlOnQuit}
                HandleRedirection={HandleRedirection}
                APIUrlRelative={FinalAPIUrlRelative}
                // APIUrlAbsolute = "null"
                FormatDataServerToForm={FormatDataServerToForm}
                FormatDataFormToServer={FormatDataFormToServer}
                FormComponent={InvoiceItemsEditForm}
                DisableToolTip={false}
                // LocaleToastMessage = en"
                // ToastDeleteConfirmation = {true}
                // ToastPublishConfirmation = {true}
                // ToastQuitWihtouSaveConfirmation = {true}
                ToastSavedMessage="Saved"
                // ToastDeletedMessage = "Delete me"
                // ToastPublishedMessage = "Publish Me"
                ButtonSaveAsDraft={{Active: false, Text: "Save draft"}}
                ButtonSaveAndQuit={{Active: true, Text: "Save And Quit"}}
                ButtonQuitNoSave={{Active: true, Text: "Exit"}}
                ButtonDelete={{Active: false, Text: "Delete"}}
                ButtonPublish={{Active: false, Text: "publier"}}
                ButtonReset={{Active: false, Text: "reseter"}}
                ButtonNext={{Active: false, Text: "Next", Save: false, FormConditions: {invalid: false, pristine: false}}}
                ButtonPrevious={{Active: false, Text: "Previous", Save: false, FormConditions: {invalid: false, pristine: false}}}
            />
        </div>
    );

    /***************** RENDER ******************/
});

export default Component;
